// src/components/core/home/TopNavigation.tsx
import React, { useState } from 'react';
import { TopNavigation } from '@cloudscape-design/components';
import { useAuthenticator } from '@aws-amplify/ui-react';
import './topnavigation.css';
import { useNavigate } from 'react-router-dom';

const TopNavigationComponent: React.FC = () => {
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const [error, setError] = useState<string | null>(null);

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (err) {
      setError('Failed to sign out. Please try again.');
      console.error('Error signing out:', err);
    }
  };

  const navigate = useNavigate();
  const handleNavigate = (link: string) => navigate(link);
  const handleFollow = (
    event:any
  ) => {
    if (event.detail.href === '/log-out') {
      event.preventDefault();
      signOut();
    }
    event.preventDefault();
    // setActiveHref(event.detail.href)
    handleNavigate(event.detail.href);
  };

  return (
    <div className='top-nav' aria-label='Top Navigation'>
      <TopNavigation
        identity={{
          href: '/',
          logo: {
            src: 'http://publicwebfilesx2nsat.s3.amazonaws.com/X2nSat_Datadel_logo_White.png',
            alt: 'X2nsat',
          },
        }}
        utilities={[
          {
            type: "menu-dropdown",
            iconName: "status-info",
            ariaLabel: "Settings",
            title: "Help",
            items: [
              {
                id: "contact-us",
                text: "Contact Us",
                href: "/support",
              },
            ],
            onItemClick: (itemId) => {
              handleFollow(itemId)
            },
          },
          {
            type: 'menu-dropdown',
            text: user?.attributes?.email || 'Account Menu',
            iconName: 'user-profile',
            items: [{ id: 'signout', text: 'Sign out' }],
            onItemClick: (itemId) => {
              if (itemId.detail.id === 'signout') {
                handleSignOut();
              }
            },
          },
        ]}
      />
      {error && <div role='alert'>{error}</div>}
    </div>
  );
};

export default TopNavigationComponent;
